import { render, staticRenderFns } from "./RewardLayout.vue?vue&type=template&id=cbed784e&scoped=true"
import script from "./RewardLayout.vue?vue&type=script&lang=js"
export * from "./RewardLayout.vue?vue&type=script&lang=js"
import style0 from "./RewardLayout.vue?vue&type=style&index=0&id=cbed784e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed784e",
  null
  
)

export default component.exports